import { IClassname } from '@/lib/shared/model/classname';

export const Oven = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7664)">
        <path
          d="M29.4182 3.85938V28.1398"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.58179 28.1398V3.85938"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.696 29.4176C30.696 29.7565 30.5614 30.0815 30.3217 30.3212C30.0821 30.5608 29.757 30.6955 29.4181 30.6955H2.58187C2.24295 30.6955 1.9179 30.5608 1.67825 30.3212C1.43859 30.0815 1.30396 29.7565 1.30396 29.4176V28.7786C1.30396 28.6091 1.37127 28.4466 1.4911 28.3268C1.61093 28.207 1.77345 28.1396 1.94291 28.1396H30.0571C30.141 28.1396 30.2241 28.1562 30.3016 28.1883C30.3791 28.2204 30.4496 28.2675 30.5089 28.3268C30.5682 28.3861 30.6153 28.4566 30.6474 28.5341C30.6795 28.6116 30.696 28.6947 30.696 28.7786V29.4176Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.77665 12.8047H26.2233C26.2233 12.8047 26.8623 12.8047 26.8623 13.4436V23.667C26.8623 23.667 26.8623 24.3059 26.2233 24.3059H5.77665C5.77665 24.3059 5.1377 24.3059 5.1377 23.667V13.4436C5.1377 13.4436 5.1377 12.8047 5.77665 12.8047Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2493 16.6387H21.7505"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1948 7.69296C19.1948 7.86077 19.2279 8.02695 19.2921 8.18199C19.3563 8.33704 19.4505 8.47791 19.5691 8.59658C19.6878 8.71524 19.8287 8.80938 19.9837 8.8736C20.1387 8.93782 20.3049 8.97087 20.4727 8.97087C20.6406 8.97087 20.8067 8.93782 20.9618 8.8736C21.1168 8.80938 21.2577 8.71524 21.3764 8.59658C21.495 8.47791 21.5892 8.33704 21.6534 8.18199C21.7176 8.02695 21.7507 7.86077 21.7507 7.69296C21.7507 7.52514 21.7176 7.35896 21.6534 7.20392C21.5892 7.04887 21.495 6.908 21.3764 6.78933C21.2577 6.67067 21.1168 6.57654 20.9618 6.51231C20.8067 6.44809 20.6406 6.41504 20.4727 6.41504C20.3049 6.41504 20.1387 6.44809 19.9837 6.51231C19.8287 6.57654 19.6878 6.67067 19.5691 6.78933C19.4505 6.908 19.3563 7.04887 19.2921 7.20392C19.2279 7.35896 19.1948 7.52514 19.1948 7.69296Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3064 7.69296C24.3064 8.03188 24.441 8.35692 24.6807 8.59658C24.9203 8.83623 25.2454 8.97087 25.5843 8.97087C25.9232 8.97087 26.2483 8.83623 26.4879 8.59658C26.7276 8.35692 26.8622 8.03188 26.8622 7.69296C26.8622 7.35403 26.7276 7.02899 26.4879 6.78933C26.2483 6.54968 25.9232 6.41504 25.5843 6.41504C25.2454 6.41504 24.9203 6.54968 24.6807 6.78933C24.441 7.02899 24.3064 7.35403 24.3064 7.69296Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.696 3.22059C30.696 3.3045 30.6795 3.38758 30.6474 3.4651C30.6153 3.54263 30.5682 3.61306 30.5089 3.6724C30.4496 3.73173 30.3791 3.7788 30.3016 3.81091C30.2241 3.84302 30.141 3.85954 30.0571 3.85954H1.94291C1.77345 3.85954 1.61093 3.79223 1.4911 3.6724C1.37127 3.55257 1.30396 3.39005 1.30396 3.22059V2.58163C1.30396 2.2427 1.43859 1.91766 1.67825 1.678C1.9179 1.43835 2.24295 1.30371 2.58187 1.30371H29.4181C29.757 1.30371 30.0821 1.43835 30.3217 1.678C30.5614 1.91766 30.696 2.2427 30.696 2.58163V3.22059Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.1377 3.85938V8.97104H16.6389V3.85938"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7664">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
